import template from './specialties.html';
import controller from './specialties.controller';
import './specialties.styl';

let specialtiesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default specialtiesComponent;



// WEBPACK FOOTER //
// ./client/app/common/admin/specialties/specialties.component.js